module.exports = __webpack_public_path__ + "static/10-88fba802185f969e59cfa4d9047a0002.jpg";